import styled from 'styled-components'
import { defaultTheme } from '../../../theme/index'
import { breakpoints } from '../../../theme/breakpoints'

export const CartSubtitle = styled.h4`
  font-family: 'Oswald', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: ${defaultTheme.colors.text};
  mix-blend-mode: normal;
  margin: 0;
  text-align: left;
`

export const StyledItemsLaborSpecsTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${defaultTheme.colors.siteBackground};
  color: ${defaultTheme.colors.primaryText};
  border-bottom: 1px solid ${defaultTheme.colors.border};
  @media (max-width: ${breakpoints.mobileLarge}px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledItemsTitle = styled(CartSubtitle)`
  padding: 20px 14px;
  @media (max-width: ${breakpoints.mobileLarge}px) {
    padding: 22px 14px;
  }
`
export const CartTable = styled.table``

export const HeaderRow = styled.thead`
  background-color: ${defaultTheme.colors.siteBackground};
  color: ${defaultTheme.colors.primaryText};
  border-bottom: 1px solid ${defaultTheme.colors.border};
  @media (max-width: ${breakpoints.mobileLarge}px) {
    display: none;
  }
`

export const LocationRow = styled.tr`
  background-color: ${defaultTheme.colors.siteBackground};
  color: ${defaultTheme.colors.primaryText};
  border-bottom: 1px solid ${defaultTheme.colors.border};
  @media (max-width: ${breakpoints.mobileLarge}px) {
    display: flex;
    flex-direction: column;
  }
`

export const ColHeader = styled.td`
  background-color: ${defaultTheme.colors.siteBackground};
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  padding: 20px 14px 20px 14px;
  text-align: left;
`

export const Hr = styled.hr`
  display: none;
  @media (max-width: ${breakpoints.laptop}px) {
    display: block;
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid ${defaultTheme.colors.border};
  }
`
